import React from 'react';

export default function BacBlock5Core() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-[#efefff] text-ink">
      <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row gap-6 lg:gap-8">
        <div className="w-full md:w-1/2">
          <div className="text-[18px] font-semibold text-ink-soft mb-6">
            La infraestructura para que las cosas ocurran
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            Una necesidad clínica sólo entra a operación cuando existe una acción concreta que debe ocurrir hoy.
          </h2>
          <div className="inline-flex items-center gap-3 border-l-2 border-brand pl-4 py-1 mt-8">
            <span className="text-[16px] font-medium text-ink-soft">Espera protegida no compite por la capacidad activa</span>
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <ul className="flex flex-col gap-6 w-full">
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Contacto</span>
              <span className="text-[14px] text-ink-soft">Interacción directa con la población a través de canales efectivos.</span>
            </li>
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Agenda</span>
              <span className="text-[14px] text-ink-soft">Integración con disponibilidad de horas y recursos.</span>
            </li>
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Confirmación</span>
              <span className="text-[14px] text-ink-soft">Aseguramiento de asistencia previa a la cita.</span>
            </li>
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Rescate</span>
              <span className="text-[14px] text-ink-soft">Reincorporación de inasistencias o abandonos al flujo.</span>
            </li>
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Capacidad y Coordinación</span>
              <span className="text-[14px] text-ink-soft">Asignación inteligente de recursos limitados.</span>
            </li>
            <li className="flex flex-col gap-1 border-b border-brand/20 pb-4">
              <span className="text-[16px] font-bold text-ink">Verificación</span>
              <span className="text-[14px] text-ink-soft">Trazabilidad de resultados para cerrar el ciclo.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
